// Date of Birth picker initialization
    (function () {
      var dobInput = document.querySelector('[name="dateOfBirth"]');
      var wrapper = dobInput && dobInput.closest('.quiz-dob-wrapper');
      if (!dobInput || !wrapper) return;

      var today = new Date();
      var yyyy = today.getFullYear();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var dd = String(today.getDate()).padStart(2, '0');
      dobInput.setAttribute('max', yyyy + '-' + mm + '-' + dd);

      function updateDobPlaceholder() {
        wrapper.classList.toggle('has-value', !!dobInput.value);
      }
      dobInput.addEventListener('change', updateDobPlaceholder);
      dobInput.addEventListener('input', updateDobPlaceholder);
      updateDobPlaceholder();
    })();

    function openCrytalsModal() {
      const quizCrytalsModalOverlay = document.querySelector('.wellness-quiz-crystals-section');
      const quizModalOverlay = document.querySelector('.quiz-modal-overlay');
      quizCrytalsModalOverlay.classList.add('active');
      quizModalOverlay.classList.add('active');
    }

    document.addEventListener("crystals-quiz:open", openCrytalsModal);

    // Prefill customer data from Shopify when logged in (run on load and after login/restore)
    function prefillCustomerData() {
      var cid = document.getElementById('quizCustomerId');
      if (!cid || !cid.value) return;

      var firstName = document.getElementById('quizCustomerFirstName')?.value || '';
      var lastName = document.getElementById('quizCustomerLastName')?.value || '';
      var email = document.getElementById('quizCustomerEmail')?.value || '';
      var street = document.getElementById('quizCustomerStreet')?.value || '';
      var city = document.getElementById('quizCustomerCity')?.value || '';
      var postalCode = document.getElementById('quizCustomerPostalCode')?.value || '';
      var countryCode = document.getElementById('quizCustomerCountryCode')?.value || '';

      var nameInput = document.querySelector('[name="name"]');
      var firstNameInput = document.querySelector('[name="firstName"]');
      var emailInput = document.querySelector('[name="email"]');
      var streetInput = document.querySelector('[name="street"]');
      var cityInput = document.querySelector('[name="city"]');
      var postalCodeInput = document.querySelector('[name="postalCode"]');
      var countryCodeInput = document.querySelector('[name="countryCode"]');

      if (nameInput && lastName) nameInput.value = lastName;
      if (firstNameInput && firstName) firstNameInput.value = firstName;
      if (emailInput && email) emailInput.value = email;
      if (streetInput && street) streetInput.value = street;
      if (cityInput && city) cityInput.value = city;
      if (postalCodeInput && postalCode) postalCodeInput.value = postalCode;
      if (countryCodeInput && countryCode) countryCodeInput.value = countryCode;
    }
    window.prefillQuizCustomerData = prefillCustomerData;
    prefillCustomerData();

// Start button functionality - Open quiz modal
    (function () {
      const startButtons = document.querySelectorAll('.quiz-goals-button, .quiz-goals-start-button');
      const startQuizFinal = document.querySelector('.quiz-goals-button-final');
      const quizGoalsMainContent = document.querySelector('.quiz-goals-main-content');
      const quizGoalsMainNoneUserContent = document.querySelector('.quiz-goals-section-none-user');
      const quizCrystalsModalOverlay = document.querySelector('.wellness-quiz-crystals-section');
      const quizModalOverlay = document.querySelector('.quiz-modal-overlay');
      const quizModalClose = document.getElementById('quizModalClose');
      const formulaRedirectModalCloseClick = document.querySelector('.formula-return-button');
      
      if (quizGoalsMainNoneUserContent) {
        startQuizFinal.addEventListener("click", function (e) {
          e.preventDefault();
          quizGoalsMainNoneUserContent.classList.remove('active');
          if (quizCrystalsModalOverlay) {
            quizCrystalsModalOverlay.style.removeProperty('display');
            quizCrystalsModalOverlay.classList.add('active');
          }
          if (quizModalOverlay) {
            quizModalOverlay.style.removeProperty('display');
            quizModalOverlay.classList.add('active');
          }
          if (typeof window.prefillQuizCustomerData === 'function') window.prefillQuizCustomerData();
        });
        // Close button - Close modal and show main content
      if (quizModalClose) {
        quizModalClose.addEventListener('click', function (e) {
          e.preventDefault();
          
          // Hide quiz-modal-overlay
          // if (quizModalOverlay) {
          //   quizModalOverlay.classList.remove('active');
          // }
          
          // Show quiz-goals-main-content
          if (quizGoalsMainNoneUserContent) {
            quizGoalsMainNoneUserContent.classList.add('active');
          }
        });
      }
      }

      // Start buttons - Open modal
      startButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          if (quizGoalsMainContent) {
            quizGoalsMainContent.classList.remove('active');
          }
          if (quizModalOverlay) {
            quizModalOverlay.style.removeProperty('display');
            quizModalOverlay.classList.add('active');
          }
          if (typeof window.prefillQuizCustomerData === 'function') window.prefillQuizCustomerData();
        });
      });

      // Close button - Close modal and show main content
      if (quizModalClose) {
        quizModalClose.addEventListener('click', function (e) {
          e.preventDefault();

           // Hide quiz-modal-overlay
          if (quizCrystalsModalOverlay) {
            quizCrystalsModalOverlay.classList.remove('active');
          }
          
          // Hide quiz-modal-overlay
          if (quizModalOverlay) {
            quizModalOverlay.classList.remove('active');
          }
          
          // Show quiz-goals-main-content
          if (quizGoalsMainContent) {
            quizGoalsMainContent.classList.add('active');
          }
        });
      }
      
      // Close button - redirecthomepage (close formula-ready-modal, reset quiz step)
      if (formulaRedirectModalCloseClick) {
        formulaRedirectModalCloseClick.addEventListener('click', function (e) {
          e.preventDefault();

          const formulaReadyPopup = document.querySelector('.formula-ready-modal');

          // Close formula-ready-modal
          if (formulaReadyPopup) {
            formulaReadyPopup.classList.remove('active');
          }

          // Hide quiz-modal-overlay
          if (quizCrystalsModalOverlay) {
            quizCrystalsModalOverlay.classList.remove('active');
          }
          
          if (quizModalOverlay) {
            quizModalOverlay.classList.remove('active');
          }

          // Reset quiz step to 1
          if (typeof window.resetQuizCrystals === 'function') {
            window.resetQuizCrystals();
          }
          
          // Show quiz-goals-main-content
          if (quizGoalsMainContent) {
            quizGoalsMainContent.classList.add('active');
          }
        });
      }
    })();

    // Quiz Navigation System
    (function () {
      const totalSteps = 11;
      let currentStep = 1;

      // Step groups mapping
      const stepGroups = {
        1: [1, 2, 3],    // Customer Data & Transmission of Findings
        2: [4, 5, 6],    // Activity & Eating Habits
        3: [7, 8],       // Diagnosis
        4: [9, 10],      // Medications & For Woman
        5: [11]          // Physical Condition
      };

      // Get current step group
      function getCurrentStepGroup(pageNumber) {
        for (const [group, pages] of Object.entries(stepGroups)) {
          if (pages.includes(pageNumber)) {
            return parseInt(group);
          }
        }
        return 1;
      }

      // Update step visibility
      function updateStepVisibility() {
        const steps = document.querySelectorAll('.quiz-modal-step');
        steps.forEach((step, index) => {
          if (index + 1 === currentStep) {
            step.classList.add('active');
          } else {
            step.classList.remove('active');
          }
        });
      }

      // Progress: 5 groups. Bar 0% at start, fills by group (0%, 20%, 40%, 60%, 80%, 100% on last step).
      function getStepIndexInGroup(step) {
        const group = getCurrentStepGroup(step);
        const pages = stepGroups[group];
        const idx = pages.indexOf(step);
        return idx >= 0 ? idx : 0;
      }
      function getStepsInGroup(step) {
        const group = getCurrentStepGroup(step);
        return stepGroups[group].length;
      }

      function updateProgressBar() {
        const progressFill = document.getElementById('modalProgressFill');
        const currentGroup = getCurrentStepGroup(currentStep);
        const stepIndexInGroup = getStepIndexInGroup(currentStep);
        const stepsInGroup = getStepsInGroup(currentStep);
        // 0% at step 1, then (group-1)*20 + (stepInGroup/stepsInGroup)*20. Last step (11) = 100%.
        let progressPercentage = 0;
        if (currentStep === 11) {
          progressPercentage = 100;
        } else {
          progressPercentage = (currentGroup - 1) * 20 + (stepIndexInGroup / stepsInGroup) * 20;
        }
        progressFill.style.width = progressPercentage + '%';

        // Progress step indicators: previous groups = completed, current = active, rest = default
        const progressSteps = document.querySelectorAll('.quiz-modal-progress-step');
        progressSteps.forEach((step, index) => {
          const stepGroup = index + 1;
          step.classList.remove('active', 'completed');
          if (stepGroup < currentGroup) {
            step.classList.add('completed');
          } else if (stepGroup === currentGroup) {
            step.classList.add('active');
          }
        });
      }

      var continueBtnSvg = '<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.67468 5.52116H0.758789V6.81088H9.67468C11.1326 6.81088 12.142 6.44639 13.5438 6.44639V6.53051C10.7681 7.98845 9.56253 9.61462 8.6373 11.1567L9.73076 12.166C11.1046 9.69873 12.7308 7.90434 15.5345 6.53051V5.82957C12.7308 4.45574 11.1046 2.63331 9.73076 0.166016L8.6373 1.2034C9.56253 2.71742 10.7681 4.34359 13.5438 5.80153V5.88565C12.142 5.88565 11.1326 5.52116 9.67468 5.52116Z" fill="white"/></svg>';

      // Update navigation buttons
      function updateNavigationButtons() {
        const previousButton = document.getElementById('previousButton');
        const continueButton = document.getElementById('continueButton');

        // Show/hide previous button
        if (currentStep === 1) {
          previousButton.style.display = 'none';
        } else {
          previousButton.style.display = 'flex';
        }

        // Last step: show "Finish" → click opens login popup if not logged in, else submits
        if (currentStep === totalSteps) {
          continueButton.innerHTML = 'Finish ' + continueBtnSvg;
        } else {
          continueButton.innerHTML = 'Continue ' + continueBtnSvg;
        }
      }

      var LABELS = {
        frequency6: ['Never','Rarely','Regularly','Daily','Daily much','Very much'],
        frequency3: ['Never','Rarely','(Almost) always'],
        physical: ['(Almost) never','Rarely','Sometimes','Often','Very often','(Almost) always'],
        liquid: ['Less than 1 liter','1-2 liters','2-3 liters','More than 3 liters'],
        alcohol: ['Never','Rarely','One glass daily','2-3 glasses daily','More than 3 glasses a day'],
        smoking: ['No','Less than 10 cigarettes/day','1 pack/day','More than 1 pack/day','More than 2 packs/day'],
        yesNo: { yes: 'Yes', no: 'No', '': '' },
        gender: { female: 'Female', male: 'Male' },
        contact: { email: 'Email', phone: 'Phone', sms: 'SMS' },
        language: { german: 'German', french: 'French', english: 'English', italian: 'Italian' },
        occupation: {
          'sedentary-lying': 'Exclusively sedentary or lying lifestyle',
          'sedentary-little-activity': 'Exclusively sedentary job with little or no strenuous leisure activity',
          'sedentary-occasional': 'Sedentary work, occasionally additional energy expenditure',
          'walking-standing': 'Predominantly walking and standing work',
          'physically-demanding': 'Physically demanding professional work'
        },
        sports: { never: 'Never', '1-3-times': '1-3 times/week', '4-or-more': '4 or more times/week' },
        allergies: {
          yes: 'Yes', gluten: 'Gluten', milk: 'Milk, Dairy products', fruits: 'Fruits in general',
          citrus: 'Citrus fruits', iodine: 'Iodine', pollen: 'Pollen, Hay fever',
          seafood: 'Seafood, Shellfish', copper: 'Copper', histamine: 'Histamine', essentialOils: 'Essential oils'
        },
        conditions: {
          acne: 'Acne', alzheimer: "Alzheimer's, Dementia", arteriosclerosis: 'Arteriosclerosis',
          osteoarthritis: 'Osteoarthritis', bronchitis: 'Bronchitis', asthma: 'Bronchial Asthma',
          bloodLipid: 'Blood Lipid Metabolism Disorder', highBloodPressure: 'High Blood Pressure',
          burnout: 'Burnout Syndrome', chronicFatigue: 'Chronic Fatigue Syndrome',
          bowelDiseases: "Bowel Diseases (Crohn's, Ulcerative Colitis)", depression: 'Depression',
          type1Diabetes: 'Type 1 Diabetes', type2Diabetes: 'Type 2 Diabetes',
          inflammatory: 'Inflammatory Diseases (Rheumatoid Arthritis)', epilepsy: 'Epilepsy',
          frequentColds: 'Frequent Colds', fibromyalgia: 'Fibromyalgia', heartDisease: 'Heart Disease',
          gastritis: 'Gastritis', hairLoss: 'Hair Loss, Brittle Nails', herpes: 'Herpes',
          cardiacArrhythmia: 'Cardiac Arrhythmia', cancer: 'Cancer (Acute, Under Treatment)',
          hyperactivity: 'Hyperactivity (ADD, Learning/Concentration Disorders)',
          cardiacInsufficiency: 'Cardiac Insufficiency', longCovid: 'Long COVID',
          macularDegeneration: 'Macular Degeneration', migraine: 'Migraine',
          multipleSclerosis: 'Multiple Sclerosis (MS)', neurodermatitis: 'Neurodermatitis',
          osteoporosis: 'Osteoporosis', periodontitis: 'Periodontitis',
          kidneyDisease: 'Kidney Disease', parkinsons: "Parkinson's", psoriasis: 'Psoriasis',
          potencyProblems: 'Potency Problems (Erectile Dysfunction)',
          thyroidDisease: 'Thyroid Disease', tinnitus: 'Tinnitus', celiacDisease: 'Celiac Disease'
        },
        medications: {
          lipidLowering: 'Lipid-lowering drugs (cholesterol-lowering)',
          antidiabetics: 'Antidiabetics or Insulin', antihypertensives: 'Antihypertensives (blood pressure-lowering)',
          diuretics: 'Diuretics (water-excreting)', bloodThinners: 'Blood thinners', hormones: 'Hormones',
          antiObesity: 'Anti-obesity drugs', goutMedications: 'Gout medications',
          antidepressants: 'Antidepressants', parkinsonsMeds: "Parkinson's medications",
          stomachMedication: 'Stomach medication (acid blockers-PPI)', painRelievers: 'Pain relievers'
        },
        cycleDay: { '01-10': '1st to 10th day', '11-17': '11th to 17th day', '18-28': '18th to 28th day' },
        noCycle: {
          child: 'Child', noUterus: 'No uterus', hormoneTherapy: 'Due to hormone therapy',
          pregnancy: 'Due to pregnancy', breastfeeding: 'Due to breastfeeding',
          menopause: 'Due to menopause', postmenopause: 'Due to postmenopause'
        }
      };

      function L(map, val) { return map[val] || val; }
      function LArr(map, arr) { return arr.map(function(v) { return map[v] || v; }); }
      function LRange(labels, val) { return labels[val] !== undefined ? labels[val] : String(val); }

      function getInputValue(name) {
        var el = document.querySelector('[name="' + name + '"]');
        return el ? el.value : '';
      }

      function getCustomerOrForm(customerFieldId, formName) {
        var cid = document.getElementById('quizCustomerId')?.value;
        if (cid) {
          var cv = document.getElementById(customerFieldId)?.value;
          if (cv) return cv;
        }
        return getInputValue(formName);
      }

      function getRadioValue(name) {
        var el = document.querySelector('[name="' + name + '"]:checked');
        return el ? el.value : '';
      }

      function getCheckedValues(name) {
        var els = document.querySelectorAll('[name="' + name + '"]:checked');
        return Array.from(els).map(function(el) { return el.value; });
      }

      function getRangeValue(name) {
        var el = document.querySelector('[name="' + name + '"]');
        return el ? parseInt(el.value, 10) : 0;
      }

      function collectQuizPayload() {
        return {
          quiz_type: 'quiz_lead',
          customer_id: document.getElementById('quizCustomerId')?.value || '',

          customer_data: JSON.stringify({
            name: getCustomerOrForm('quizCustomerLastName', 'name'),
            first_name: getCustomerOrForm('quizCustomerFirstName', 'firstName'),
            email: getCustomerOrForm('quizCustomerEmail', 'email'),
            contact_method: LArr(LABELS.contact, getCheckedValues('contactMethod')),
            date_of_birth: (function() {
              var v = getInputValue('dateOfBirth');
              if (!v) return '';
              var parts = v.split('-');
              var monthNames = ['','January','February','March','April','May','June','July','August','September','October','November','December'];
              return parts[2] + ' ' + monthNames[parseInt(parts[1], 10)] + ' ' + parts[0];
            })(),
            gender: L(LABELS.gender, getRadioValue('gender')),
            height: getInputValue('height') + ' cm',
            weight: getInputValue('weight') + ' kg'
          }),

          address: JSON.stringify({
            street: getCustomerOrForm('quizCustomerStreet', 'street'),
            house_number: getInputValue('houseNumber'),
            postal_code: getCustomerOrForm('quizCustomerPostalCode', 'postalCode'),
            city: getCustomerOrForm('quizCustomerCity', 'city'),
            country_code: getCustomerOrForm('quizCustomerCountryCode', 'countryCode'),
            change_of_address: L(LABELS.yesNo, getRadioValue('changeOfAddress')),
            parent_name: getInputValue('parentName')
          }),

          transmission_findings: JSON.stringify({
            detailed_report_consultation: document.querySelector('[name="detailedReportConsultation"]')?.checked ? 'Yes' : 'No',
            appointment_request: getInputValue('appointmentRequest'),
            detailed_report: document.querySelector('[name="detailedReport"]')?.checked ? 'Yes' : 'No',
            third_party_lab_data: document.querySelector('[name="thirdPartyLabData"]')?.checked ? 'Yes' : 'No',
            personal_recommendation: document.querySelector('[name="personalRecommendation"]')?.checked ? 'Yes' : 'No',
            language: LArr(LABELS.language, getCheckedValues('language'))
          }),

          activity: JSON.stringify({
            occupation: LArr(LABELS.occupation, getCheckedValues('occupation')),
            sports_frequency: LArr(LABELS.sports, getCheckedValues('sportsFrequency'))
          }),

          eating_habits: JSON.stringify({
            meat_consumption: LRange(LABELS.frequency6, getRangeValue('meatConsumption')),
            fish_consumption: LRange(LABELS.frequency6, getRangeValue('fishConsumption')),
            egg_consumption: LRange(LABELS.frequency6, getRangeValue('eggConsumption')),
            dairy_consumption: LRange(LABELS.frequency6, getRangeValue('dairyConsumption')),
            fruit_veg_consumption: LRange(LABELS.frequency6, getRangeValue('fruitVegConsumption')),
            liquid_intake: LRange(LABELS.liquid, getRangeValue('liquidIntake')),
            alcohol_consumption: LRange(LABELS.alcohol, getRangeValue('alcoholConsumption')),
            smoking_amount: LRange(LABELS.smoking, getRangeValue('smokingAmount')),
            smoking_environment: L(LABELS.yesNo, getRadioValue('smokingEnvironment')),
            allergies: LArr(LABELS.allergies, getCheckedValues('allergies'))
          }),

          diagnosis: JSON.stringify({
            constipation: LRange(LABELS.frequency3, getRangeValue('constipation')),
            diarrhea: LRange(LABELS.frequency3, getRangeValue('diarrhea')),
            stomach_irritation: L(LABELS.yesNo, getRadioValue('stomachIrritation')),
            heartburn: L(LABELS.yesNo, getRadioValue('heartburn')),
            cancer_therapy: L(LABELS.yesNo, getRadioValue('cancerTherapy')),
            immune_system: L(LABELS.yesNo, getRadioValue('immuneSystem')),
            covid_vaccination: L(LABELS.yesNo, getRadioValue('covidVaccination')),
            libido_problems: L(LABELS.yesNo, getRadioValue('libidoProblems')),
            conditions: LArr(LABELS.conditions, getCheckedValues('conditions'))
          }),

          medications_data: JSON.stringify({
            medications: LArr(LABELS.medications, getCheckedValues('medications')),
            other_medications: getInputValue('otherMedications'),
            micronutrients: getInputValue('micronutrients'),
            other_meds: getInputValue('otherMeds'),
            dosage_reduced: L(LABELS.yesNo, getRadioValue('dosageReduced'))
          }),

          for_women: JSON.stringify({
            menstrual_problems: L(LABELS.yesNo, getRadioValue('menstrualProblems')),
            menopausal_symptoms: LArr(LABELS.yesNo, getCheckedValues('menopausalSymptoms')),
            cycle_day: LArr(LABELS.cycleDay, getCheckedValues('cycleDay')),
            no_cycle: LArr(LABELS.noCycle, getCheckedValues('noCycle'))
          }),

          physical_condition: JSON.stringify({
            sleep_quality: LRange(LABELS.physical, getRangeValue('sleepQuality')),
            calm_composed: LRange(LABELS.physical, getRangeValue('calmComposed')),
            good_mood: LRange(LABELS.physical, getRangeValue('goodMood')),
            full_of_energy: LRange(LABELS.physical, getRangeValue('fullOfEnergy')),
            stress_level: LRange(LABELS.physical, getRangeValue('stressLevel')),
            discouraged_sad: LRange(LABELS.physical, getRangeValue('discouragedSad')),
            vitality_restriction: LRange(LABELS.physical, getRangeValue('vitalityRestriction')),
            depressed_anxious: LRange(LABELS.physical, getRangeValue('depressedAnxious')),
            mental_restrictions: LRange(LABELS.physical, getRangeValue('mentalRestrictions')),
            joint_pain: LRange(LABELS.physical, getRangeValue('jointPain')),
            other_physical_pain: LRange(LABELS.physical, getRangeValue('otherPhysicalPain'))
          }),

          created_at: new Date().toISOString()
        };
      }

      function saveFormState() {
        var state = { step: currentStep, fields: {} };
        document.querySelectorAll('.quiz-modal input, .quiz-modal select').forEach(function(el) {
          var key = el.name || el.id;
          if (!key) return;
          if (el.type === 'checkbox' || el.type === 'radio') {
            if (!state.fields[key]) state.fields[key] = { type: el.type, values: [] };
            if (el.checked) state.fields[key].values.push(el.value);
          } else {
            state.fields[key] = { type: 'value', value: el.value };
          }
        });
        sessionStorage.setItem('quizFormState', JSON.stringify(state));
      }

      function restoreFormState() {
        var raw = sessionStorage.getItem('quizFormState');
        if (!raw) return false;
        try {
          var state = JSON.parse(raw);
          Object.keys(state.fields).forEach(function(key) {
            var f = state.fields[key];
            if (f.type === 'checkbox' || f.type === 'radio') {
              document.querySelectorAll('[name="' + key + '"]').forEach(function(el) {
                el.checked = f.values.includes(el.value);
              });
            } else {
              var el = document.querySelector('[name="' + key + '"]') || document.getElementById(key);
              if (el) el.value = f.value || '';
            }
          });
          currentStep = state.step || 1;
          updateStepVisibility();
          updateProgressBar();
          updateNavigationButtons();
          return true;
        } catch (e) {
          return false;
        }
      }

      function clearFormState() {
        sessionStorage.removeItem('quizFormState');
        sessionStorage.removeItem('quizPendingSubmit');
      }

      function clearQuizFormInputs() {
        var modal = document.querySelector('.quiz-modal');
        if (!modal) return;
        modal.querySelectorAll('input:not([type="hidden"])').forEach(function(el) {
          if (el.type === 'checkbox' || el.type === 'radio') {
            el.checked = false;
          } else if (el.type === 'range') {
            el.value = el.defaultValue || el.getAttribute('value') || el.min || 0;
          } else {
            el.value = '';
          }
        });
        modal.querySelectorAll('select').forEach(function(el) {
          el.selectedIndex = 0;
        });
      }

      function buildFormulaPayload() {
        var FREQ6 = ['never','rarely','regularly','daily','daily_much','very_much'];
        var FREQ3 = ['never','rarely','always'];
        var FREQ5_PHYS = ['almost_never','rarely','sometimes','often','often','almost_always'];
        var LIQUID = ['lt1','1_2','2_3','gt3'];
        var ALCOHOL = ['never','rarely','daily','daily','daily'];
        var SMOKING = ['no','lt10_per_day','1_pack_per_day','gt1_pack_per_day','gt2_packs_per_day'];
        var OCCUPATION = {'sedentary-lying':1,'sedentary-little-activity':1,'sedentary-occasional':2,'walking-standing':3,'physically-demanding':4};
        var SPORTS = {'never':'never','1-3-times':'1_3_times','4-or-more':'4_plus'};
        var ALLERGY = {'gluten':'gluten','milk':'milk_dairy','fruits':'fruits_general','citrus':'citrus_fruits','iodine':'iodine','pollen':'pollen_hay_fever','seafood':'seafood_shellfish','copper':'copper','histamine':'histamine','essentialOils':'essential_oils'};
        var CONDITIONS = {'acne':'acne','alzheimer':'alzheimers_dementia','arteriosclerosis':'arteriosclerosis','osteoarthritis':'osteoarthritis','bronchitis':'bronchitis','asthma':'bronchial_asthma','bloodLipid':'blood_lipid_disorder','depression':'depression','diabetes':'type2_diabetes','hypothyroidism':'thyroid_hypo','hypertension':'high_blood_pressure','osteoporosis':'osteoporosis','hairLoss':'hair_loss_brittle_nails','tinnitus':'tinnitus','cancer':'cancer_acute_under_treatment','fatigue':'chronic_fatigue_cfs'};

        var dobEl = document.querySelector('[name="dateOfBirth"]');
        var dob = dobEl ? dobEl.value : '';
        var age = null;
        if (dob) {
          var parts = dob.split('-');
          if (parts.length === 3) {
            var birthDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
            var ageCalc = Math.floor((Date.now() - birthDate.getTime()) / 31557600000);
            if (ageCalc >= 1) age = ageCalc;
          }
        }
        var gender = getRadioValue('gender') || null;
        var height = parseFloat(getInputValue('height')) || null;
        var weight = parseFloat(getInputValue('weight')) || null;
        var occVals = getCheckedValues('occupation');
        var occupation_level = occVals.length ? (OCCUPATION[occVals[0]] || null) : null;
        var sportsVals = getCheckedValues('sportsFrequency');
        var sports_per_week = sportsVals.length ? (SPORTS[sportsVals[0]] || null) : null;
        var allergies = getCheckedValues('allergies').filter(function(v){return v!=='yes';}).map(function(v){return ALLERGY[v];}).filter(Boolean);
        var conditions = getCheckedValues('conditions').map(function(v){return CONDITIONS[v];}).filter(Boolean);

        var r = {};
        if (age !== null) r.age = age;
        if (gender) r.gender = gender;
        if (height) r.height_cm = height;
        if (weight) r.weight_kg = weight;
        r.meat = FREQ6[getRangeValue('meatConsumption')];
        r.fish = FREQ6[getRangeValue('fishConsumption')];
        r.eggs = FREQ6[getRangeValue('eggConsumption')];
        r.dairy = FREQ6[getRangeValue('dairyConsumption')];
        r.fruit_veg = FREQ6[getRangeValue('fruitVegConsumption')];
        r.liquid = LIQUID[getRangeValue('liquidIntake')];
        r.alcohol = ALCOHOL[getRangeValue('alcoholConsumption')];
        r.smoking = SMOKING[getRangeValue('smokingAmount')];
        r.passive_smoke_common = getRadioValue('smokingEnvironment') === 'yes';
        if (allergies.length) r.allergies_intolerances = allergies;
        if (occupation_level !== null) r.occupation_level = occupation_level;
        if (sports_per_week) r.sports_per_week = sports_per_week;
        r.constipation = FREQ3[getRangeValue('constipation')];
        r.diarrhea = FREQ3[getRangeValue('diarrhea')];
        r.recurring_stomach_irritation_or_ulcers = getRadioValue('stomachIrritation') === 'yes';
        r.recurring_heartburn = getRadioValue('heartburn') === 'yes';
        r.has_cancer_therapy_completed = getRadioValue('cancerTherapy') === 'yes';
        r.immune_strengthening_risk = getRadioValue('immuneSystem') === 'yes';
        r.covid19_vaccination_received = getRadioValue('covidVaccination') === 'yes';
        r.libido_problems = getRadioValue('libidoProblems') === 'yes';
        if (conditions.length) r.diagnoses = conditions;
        r.dose_reduced_due_to_strong_reaction = getRadioValue('dosageReduced') === 'yes';
        r.can_sleep_well = FREQ5_PHYS[getRangeValue('sleepQuality')];
        r.calm_and_composed = FREQ5_PHYS[getRangeValue('calmComposed')];
        r.in_good_mood = FREQ5_PHYS[getRangeValue('goodMood')];
        r.full_of_energy = FREQ5_PHYS[getRangeValue('fullOfEnergy')];
        r.feel_stressed = FREQ5_PHYS[getRangeValue('stressLevel')];
        r.discouraged_and_sad = FREQ5_PHYS[getRangeValue('discouragedSad')];
        r.restricted_in_vitality = FREQ5_PHYS[getRangeValue('vitalityRestriction')];
        r.depressed_or_anxious = FREQ5_PHYS[getRangeValue('depressedAnxious')];
        r.mental_restrictions_prevented_activities = FREQ5_PHYS[getRangeValue('mentalRestrictions')];
        r.joint_pain = FREQ5_PHYS[getRangeValue('jointPain')];
        r.other_physical_pain = FREQ5_PHYS[getRangeValue('otherPhysicalPain')];

        var customerId = (document.getElementById('quizCustomerId') || {}).value || '';
        var emailEl = document.querySelector('[name="email"]');
        return {
          user: { shopify_user_id: customerId, email: emailEl ? emailEl.value : '' },
          responses: r,
          labs: {}
        };
      }

      async function submitQuizData() {
        var payload = collectQuizPayload();
        var RITUAL_QUIZ_API_KEY = "60336a62f94660ae06744c6b17e1271014bd8f8d87ccaf5dbd50b02f5d5f1fc8";
        var FORMULA_API_KEY = "352940dbd2bccb60d9238f64e043fe498a95659e86298150d0d10d43821314fc";
        var FORMULA_URL = "https://simple-recommendation.botano.com/v1/formula/base";

        var recommendations = [];
        var total_grams = 0;
        try {
          var formulaResp = await fetch(FORMULA_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-API-Key': FORMULA_API_KEY },
            body: JSON.stringify(buildFormulaPayload())
          });
          if (formulaResp.ok) {
            var formulaData = await formulaResp.json();
            recommendations = formulaData.recommendations || [];
            total_grams = formulaData.total_grams || 0;
          }
        } catch(e) {
          console.warn('[Quiz] Formula engine error, continuing without recommendations:', e);
        }

        try {
          var response = await fetch('https://nutrition-quiz-shopify-api.botano.com/api/lead', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', "X-API-Key": RITUAL_QUIZ_API_KEY },
            body: JSON.stringify(Object.assign({}, payload, {
              formula_recommendations: recommendations,
              total_grams: total_grams
            }))
          });

          var result = await response.json();

          if (!response.ok) {
            throw new Error(result.error || 'Server error');
          }

          clearFormState();
          clearQuizFormInputs();
          if (typeof window.prefillQuizCustomerData === 'function') window.prefillQuizCustomerData();

          window._lastFormulaRecommendations = recommendations.length > 0 ? recommendations : null;
          if (recommendations.length > 0) {
            try { localStorage.setItem('_formulaRecs', JSON.stringify(recommendations)); } catch(e) {}
          }
          var leadId = (typeof result !== 'undefined' && result.lead_id) ? result.lead_id : null;
          if (leadId) {
            try { localStorage.setItem('_formulaLeadId', leadId); } catch(e) {}
          }

          if (recommendations.length > 0) {
            document.dispatchEvent(new CustomEvent('formula-prescription:open', {
              detail: { recommendations: recommendations }
            }));
          } else {
            document.dispatchEvent(new CustomEvent('formula-prescription:open', { detail: {} }));
          }

          return true;
        } catch (error) {
          console.error('[Quiz Crystals] Submit error:', error);
          return false;
        }
      }

      function validateStep(step) {
        if (step === 1) {
          var dob = document.querySelector('[name="dateOfBirth"]');
          var height = document.querySelector('[name="height"]');
          var weight = document.querySelector('[name="weight"]');
          var gender = document.querySelector('[name="gender"]:checked');
          if (!dob || !dob.value) { dob && dob.focus(); alert('Please enter your date of birth.'); return false; }
          if (dob && dob.value) {
            var dobParts = dob.value.split('-');
            if (dobParts.length === 3) {
              var dobDate = new Date(parseInt(dobParts[0]), parseInt(dobParts[1]) - 1, parseInt(dobParts[2]));
              var dobAge = Math.floor((Date.now() - dobDate.getTime()) / 31557600000);
              if (dobAge < 18) { dob.focus(); alert('You must be at least 18 years old to use this service.'); return false; }
            }
          }
          if (!gender) { alert('Please select your gender.'); return false; }
          if (!height || !height.value) { height && height.focus(); alert('Please enter your height.'); return false; }
          if (!weight || !weight.value) { weight && weight.focus(); alert('Please enter your weight.'); return false; }
        }
        if (step === 4) {
          var occupation = document.querySelector('[name="occupation"]:checked');
          var sports = document.querySelector('[name="sportsFrequency"]:checked');
          if (!occupation) { alert('Please select your occupation level.'); return false; }
          if (!sports) { alert('Please select your sports frequency.'); return false; }
        }
        return true;
      }

      // Navigate to next step
      function goToNextStep() {
        if (!validateStep(currentStep)) return;
        if (currentStep < totalSteps) {
          currentStep++;
          updateStepVisibility();
          updateProgressBar();
          updateNavigationButtons();
        } else if (currentStep === totalSteps) {
          var quizModalOverlay = document.querySelector('.quiz-modal-overlay');
          var formulaReadyModal = document.querySelector('.formula-ready-modal');
          var loginModal = document.getElementById('quizLoginModal');
          var isLoggedIn = !!(document.getElementById('quizCustomerId')?.value);

          if (!isLoggedIn) {
            saveFormState();
            sessionStorage.setItem('quizPendingSubmit', '1');
            if (quizModalOverlay) quizModalOverlay.classList.remove('active');
            if (loginModal) loginModal.classList.add('active');
          } else {
            var continueBtn = document.getElementById('continueButton');
            var loadingCard = document.getElementById('formulaLoadingCard');
            var readyCard = document.getElementById('formulaReadyCard');

            if (quizModalOverlay) quizModalOverlay.classList.remove('active');
            if (formulaReadyModal) formulaReadyModal.classList.add('active');
            if (loadingCard) loadingCard.style.display = '';
            if (readyCard) readyCard.style.display = 'none';

            if (continueBtn) {
              continueBtn.disabled = true;
              continueBtn.innerHTML = '<span class="quiz-btn-spinner"></span> Submitting...';
            }

            submitQuizData().then(function(success) {
              if (continueBtn) {
                continueBtn.disabled = false;
                continueBtn.innerHTML = 'Continue <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.67468 5.52116H0.758789V6.81088H9.67468C11.1326 6.81088 12.142 6.44639 13.5438 6.44639V6.53051C10.7681 7.98845 9.56253 9.61462 8.6373 11.1567L9.73076 12.166C11.1046 9.69873 12.7308 7.90434 15.5345 6.53051V5.82957C12.7308 4.45574 11.1046 2.63331 9.73076 0.166016L8.6373 1.2034C9.56253 2.71742 10.7681 4.34359 13.5438 5.80153V5.88565C12.142 5.88565 11.1326 5.52116 9.67468 5.52116Z" fill="white"/></svg>';
              }
              if (success) {
                if (loadingCard) loadingCard.style.display = 'none';
                if (readyCard) readyCard.style.display = '';
              } else {
                if (formulaReadyModal) formulaReadyModal.classList.remove('active');
                if (quizModalOverlay) {
                  quizModalOverlay.style.removeProperty('display');
                  quizModalOverlay.classList.add('active');
                }
                updateNavigationButtons();
              }
            });
          }
        }
      }

      // Navigate to previous step
      function goToPreviousStep() {
        if (currentStep > 1) {
          currentStep--;
          updateStepVisibility();
          updateProgressBar();
          updateNavigationButtons();
        }
      }

      // Reset quiz to step 1 (exposed for Homepage button)
      function resetQuizToStep1() {
        currentStep = 1;
        clearFormState();
        updateStepVisibility();
        updateProgressBar();
        updateNavigationButtons();
      }
      window.resetQuizCrystals = resetQuizToStep1;

      // Legacy login/sign-up panel toggle — no-op under New Customer Accounts (Sign in CTA only)
      function bindLoginSignupToggle() {}

      // Initialize
      function init() {
        var isLoggedIn = !!(document.getElementById('quizCustomerId')?.value);
        var hasPending = sessionStorage.getItem('quizPendingSubmit') === '1';

        if (isLoggedIn && hasPending) {
          var quizModalOverlay = document.querySelector('.quiz-modal-overlay');
          var crystalsSection = document.querySelector('.wellness-quiz-crystals-section');
          if (quizModalOverlay) {
            quizModalOverlay.classList.remove('active');
          }
          if (crystalsSection) crystalsSection.classList.add('active');
        }

        updateStepVisibility();
        updateProgressBar();
        updateNavigationButtons();
        bindLoginSignupToggle();

        document.getElementById('continueButton').addEventListener('click', goToNextStep);
        document.getElementById('previousButton').addEventListener('click', goToPreviousStep);

        if (isLoggedIn && hasPending) {
          var restored = restoreFormState();
          if (restored) {
            sessionStorage.removeItem('quizPendingSubmit');
            var quizModalOverlay = document.querySelector('.quiz-modal-overlay');
            var crystalsSection = document.querySelector('.wellness-quiz-crystals-section');
            var formulaReadyModal = document.querySelector('.formula-ready-modal');
            var loadingCard = document.getElementById('formulaLoadingCard');
            var readyCard = document.getElementById('formulaReadyCard');
            if (quizModalOverlay) {
              quizModalOverlay.classList.remove('active');
            }
            if (crystalsSection) crystalsSection.classList.add('active');
            if (formulaReadyModal) formulaReadyModal.classList.add('active');
            if (loadingCard) loadingCard.style.display = '';
            if (readyCard) readyCard.style.display = 'none';
            submitQuizData().then(function(success) {
              if (success) {
                if (loadingCard) loadingCard.style.display = 'none';
                if (readyCard) readyCard.style.display = '';
              } else {
                if (formulaReadyModal) formulaReadyModal.classList.remove('active');
                if (quizModalOverlay) {
                  quizModalOverlay.style.removeProperty('display');
                  quizModalOverlay.classList.add('active');
                }
                updateNavigationButtons();
              }
            });
          } else {
            clearFormState();
          }
        }
        prefillCustomerData();

        var dobInput = document.getElementById('quizDobInput');
        if (dobInput) {
          var today = new Date();
          var maxDate = today.getFullYear() + '-' +
            String(today.getMonth() + 1).padStart(2, '0') + '-' +
            String(today.getDate()).padStart(2, '0');
          dobInput.setAttribute('max', maxDate);
        }
      }

      // Run on DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();

    // Formula Popup functionality
    (function () {
      const formulaPopup = document.getElementById('formulaPopup');
      const formulaPopupClose = document.getElementById('formulaPopupClose');
      const formulaReturnButtons = document.querySelectorAll('.formula-return-button');
      const formulaReadyModal = document.querySelector('.formula-ready-modal');

      // Open popup when formula-return-button is clicked
      formulaReturnButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          if (formulaPopup) {
            // Remove active class from formula-ready-modal
            if (formulaReadyModal) {
              formulaReadyModal.classList.remove('active');
            }
            // Open formula popup
            formulaPopup.classList.add('active');
          }
        });
      });

      // Close popup
      if (formulaPopupClose) {
        formulaPopupClose.addEventListener('click', function () {
          const quizGoalsMainContent = document.querySelector('.quiz-goals-main-content');
          const quizModalOverlay = document.querySelector('.quiz-modal-overlay');
          
          if (formulaPopup) {
            formulaPopup.classList.remove('active');
          }
          
          // Hide quiz-modal-overlay
          if (quizModalOverlay) {
            quizModalOverlay.classList.remove('active');
          }
          
          // Show quiz-goals-main-content
          if (quizGoalsMainContent) {
            quizGoalsMainContent.classList.add('active');
          }
        });
      }

      // Close popup when clicking overlay
      if (formulaPopup) {
        formulaPopup.addEventListener('click', function (e) {
          if (e.target === formulaPopup) {
            const quizGoalsMainContent = document.querySelector('.quiz-goals-main-content');
            const quizModalOverlay = document.querySelector('.quiz-modal-overlay');
            
            formulaPopup.classList.remove('active');
            
            // Hide quiz-modal-overlay
            if (quizModalOverlay) {
              quizModalOverlay.classList.remove('active');
            }
            
            // Show quiz-goals-main-content
            if (quizGoalsMainContent) {
              quizGoalsMainContent.classList.add('active');
            }
          }
        });
      }

      // Close popup with ESC key
      // document.addEventListener('keydown', function (e) {
      //   if (e.key === 'Escape' && formulaPopup && formulaPopup.classList.contains('active')) {
      //     const quizGoalsMainContent = document.querySelector('.quiz-goals-main-content');
      //     const quizModalOverlay = document.querySelector('.quiz-modal-overlay');
          
      //     formulaPopup.classList.remove('active');
          
      //     // Hide quiz-modal-overlay
      //     if (quizModalOverlay) {
      //       quizModalOverlay.classList.remove('active');
      //     }
          
      //     // Show quiz-goals-main-content
      //     if (quizGoalsMainContent) {
      //       quizGoalsMainContent.classList.add('active');
      //     }
      //   }
      // });

      // Goal selection functionality
      const goalItems = document.querySelectorAll('.quiz-goal-item');
      goalItems.forEach((item) => {
        item.addEventListener('click', function () {
          this.classList.toggle('selected');
        });
      });

      // Goal filter functionality in popup
      const formulaGoalFilters = document.querySelectorAll('.formula-goal-filter');
      formulaGoalFilters.forEach((filter) => {
        filter.addEventListener('click', function () {
          this.classList.toggle('selected');
        });
      });
    })();
